import classnames from 'classnames';

import textClassSwitcher from '../../utils/textClassSwitcher';

import * as styles from '../Testimonials.css';
import type { TTestimonialAttributes } from '../Testimonials.types';

interface Props {
  description: string;
  className?: string;
  attributes?: TTestimonialAttributes;
}

const Description = ({ description, className = '', attributes }: Props) => {
  return (
    <span
      className={classnames(
        styles.testimonialsDescription,
        textClassSwitcher(className, attributes?.descriptionFontSize || 'text-xs'),
      )}
    >
      {description}
    </span>
  );
};

export default Description;
